import banner from '@assets/login/banner.webp';
import { ThemeToggle } from '@components/ui';
import { useSession } from '@lib/auth/session';
import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';
import type { ReactNode } from 'react';

interface ScreenWrapperProps {
  children: ReactNode;
  pageSx?: SxProps<Theme>;
  containerSx?: SxProps<Theme>;
}

const ScreenWrapper = ({
  children,
  pageSx,
  containerSx,
}: ScreenWrapperProps): JSX.Element => {
  const loggedIn = useSession();

  return (
    <Box
      sx={[
        {
          position: 'relative',
          height: '100dvh',
          maxHeight: '100dvh',
          width: '100%',
          overflow: 'hidden',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          backgroundImage: `url(${banner})`,
        },
        ...(Array.isArray(pageSx) ? pageSx : [pageSx]),
      ]}
    >
      <Box
        sx={{
          pointerEvents: 'none',
          position: 'fixed',
          inset: 0,
          zIndex: 0,
          bgcolor: 'background.default',
          opacity: 0.8,
          backdropFilter: 'blur(12px)',
        }}
      />
      {!loggedIn ? (
        <Box
          sx={{
            position: 'fixed',
            right: { xs: 16, sm: 24 },
            top: { xs: 16, sm: 24 },
            zIndex: 20,
          }}
        >
          <ThemeToggle />
        </Box>
      ) : null}
      <Box
        className="screen-wrapper__container"
        sx={[
          {
            position: 'relative',
            zIndex: 1,
            height: '100%',
            width: '100%',
            boxSizing: 'border-box',
            pb: 'var(--app-banner-space, 0px)',
            // Keeps the fixed theme toggle clear of the card on phones
            pt: loggedIn ? 0 : { xs: 7, sm: 0 },
          },
          ...(Array.isArray(containerSx) ? containerSx : [containerSx]),
        ]}
      >
        {children}
      </Box>
    </Box>
  );
};
export default ScreenWrapper;
